import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, UserSession } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import userService from "../services/userService";
import { Checkbox } from "primereact/checkbox";

export default class HowToUse extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    async componentDidMount() {
        try {
            await showProcess();

            if (UserSession !== null && UserSession !== undefined && UserSession !== "") {
                const response = await userService.getById(UserSession.id);

                if (response.status === 200) {
                    this.setState({ user: response.data });
                } else {
                    alert("ERRO AO CARREGAR PAGINA");
                }
            }
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    formatarTelefone(telefone) {
        telefone = telefone.replace(/\D/g, "");

        // Verifica se tem DDD
        if (telefone.length <= 10) {
            // Formato: (XX) XXXX-XXXX
            return telefone.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
        } else {
            // Formato: (XX) XXXXX-XXXX
            return telefone.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
        }
    }

    render() {
        return (
            <>
                <div
                    style={{
                        width: "100%",
                        backgroundColor: "var(--unnamed-color-411172)",
                        paddingTop: "25px",
                        paddingBottom: "50px",
                        paddingRight: "5%",
                        paddingLeft: "5%",
                        boxSizing: "border-box",
                    }}
                >
                    <a
                        href="/"
                        style={{
                            color: "#C4B9DB",
                            textDecoration: "underline",
                            fontSize: "16px",
                        }}
                    >
                        Home
                    </a>
                    <span style={{ marginLeft: "10px" }} />
                    <a
                        style={{
                            color: "#C4B9DB",
                            textDecoration: "underline",
                            fontSize: "16px",
                        }}
                    >
                        Como Utilizar
                    </a>
                    <br />
                    <br />
                    <a
                        style={{
                            color: "#FFFFFF",
                            fontWeight: "bold",
                            fontSize: window.innerWidth < 768 ? "26px" : "50px",
                            marginLeft: window.innerWidth < 768 ? "0" : "5%",
                            display: "block",
                            textAlign: window.innerWidth < 768 ? "center" : "left",
                            lineHeight: "1.3",
                        }}
                    >
                        Como resgatar o cartão-presente multimarcas
                    </a>
                </div>

                {/* Conteúdo */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        overflowX: "hidden",
                        padding: window.innerWidth < 768 ? "0 5%" : "0",
                        boxSizing: "border-box",
                    }}
                >
                    {[
                        {
                            num: 1,
                            text1: "Acesse o site",
                            text2: "insira o código do cartão e o PIN recebido no e-mail.",
                            link: "https://www.omelhorpresentepara.com.br",
                            img: require("../img/use1.png"),
                            invert: false,
                        },
                        {
                            num: 2,
                            text1: "Escolha",
                            text2: "até duas marcas para utilizar o saldo de créditos recebido.",
                            img: require("../img/use2.png"),
                            invert: true,
                        },
                        {
                            num: 3,
                            text1: "Insira o email",
                            text2: "para receber o código de ativação e as instruções para resgatar os créditos nas plataformas da(s) marca(s) escolhida(s).",
                            img: require("../img/use3.png"),
                            invert: false,
                        },
                        {
                            num: 4,
                            text1: "Pronto!",
                            text2: "Acesse a plataforma da(s) marca(s) escolhida(s) e siga as instruções recebidas no e-mail para resgatar os créditos.",
                            img: require("../img/use2.png"),
                            invert: true,
                        },
                    ].map((step, index) => (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                flexDirection:
                                    window.innerWidth < 768
                                        ? "column"
                                        : step.invert
                                          ? "row-reverse"
                                          : "row",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: "50px",
                                width: "100%",
                                maxWidth: "1200px",
                                textAlign: window.innerWidth < 768 ? "center" : "left",
                                overflow: "hidden",
                            }}
                        >
                            <img
                                src={step.img}
                                alt={`passo-${step.num}`}
                                style={{
                                    width: window.innerWidth < 768 ? "90%" : "512px",
                                    height: "auto",
                                    marginBottom: window.innerWidth < 768 ? "20px" : "0",
                                }}
                            />
                            <div
                                style={{
                                    lineHeight: "60px",
                                    padding: window.innerWidth < 768 ? "0 10px" : "0 40px",
                                }}
                            >
                                <div
                                    style={{
                                        width: "96px",
                                        height: "96px",
                                        borderRadius: "50%",
                                        border: "2px solid var(--unnamed-color-411172)",
                                        color: "var(--unnamed-color-411172)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "80px",
                                        margin:
                                            window.innerWidth < 768
                                                ? "0 auto 20px auto"
                                                : "0 0 20px 0",
                                    }}
                                >
                                    {step.num}
                                </div>
                                <label
                                    style={{
                                        color: "var(--unnamed-color-411172)",
                                        fontSize: window.innerWidth < 768 ? "28px" : "50px",
                                        fontWeight: "bold",
                                        display: "block",
                                    }}
                                >
                                    {step.text1}
                                </label>
                                {step.link ? (
                                    <>
                                        <a
                                            href={step.link}
                                            style={{
                                                color: "#209ADB",
                                                fontSize: window.innerWidth < 768 ? "28px" : "50px",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {step.link.replace("https://", "")}
                                        </a>
                                        <label
                                            style={{
                                                color: "var(--unnamed-color-411172)",
                                                fontSize: window.innerWidth < 768 ? "28px" : "50px",
                                                display: "block",
                                            }}
                                        >
                                            {" e " + step.text2}
                                        </label>
                                    </>
                                ) : (
                                    <label
                                        style={{
                                            color: "var(--unnamed-color-411172)",
                                            fontSize: window.innerWidth < 768 ? "28px" : "50px",
                                            display: "block",
                                        }}
                                    >
                                        {step.text2}
                                    </label>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </>
        );
    }
}
